import React, { useRef, useState, useEffect } from 'react';
import IdleTimer from 'react-idle-timer';
import {
  useUserDispatch,
  useUserState,
} from '../context/UserContext/UserContext';
import IdleModal from '../shared/IdleModal';
import { useSession } from '../context/SessionContext/SessionContext';

const IdleTimerContainer = ({ children }) => {
  const userState = useUserState();
  const sessionDispatch = useUserDispatch();
  const { isSessionPaused } = useSession();

  const timeoutTime = process.env.REACT_APP_IDLE_TIMEOUT
    ? Number(process.env.REACT_APP_IDLE_TIMEOUT) * 60 * 1000
    : 60000;

  const idleTimerRef = useRef(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const sessionTimeoutRef = useRef(null);

  const logOut = () => {
    setModalIsOpen(false);
    clearTimeout(sessionTimeoutRef.current);
    sessionDispatch({ type: 'LOGOUT' });
  };

  const onIdle = () => {
    if (isSessionPaused) {
      return;
    }

    setModalIsOpen(true);

    sessionTimeoutRef.current = setTimeout(() => {
      logOut();
    }, 60000);
  };

  const stayActive = () => {
    setModalIsOpen(false);
    clearTimeout(sessionTimeoutRef.current);

    idleTimerRef.current?.reset();
  };

  // 🔥 Track enable / disable state
  useEffect(() => {
    if (!idleTimerRef.current) return;

    if (isSessionPaused) {
    } else {
      idleTimerRef.current.reset();
    }
  }, [isSessionPaused]);

  return userState.isLoggedIn ? (
    <IdleTimer
      ref={idleTimerRef}
      timeout={timeoutTime}
      onIdle={onIdle}
      debounce={500}
      disabled={isSessionPaused}
    >
      {modalIsOpen && (
        <IdleModal isVisible={modalIsOpen} onYes={stayActive} onNo={logOut} />
      )}
      {children}
    </IdleTimer>
  ) : (
    children
  );
};

export default IdleTimerContainer;
